export default __webpack_public_path__ + "static/media/masjid img 4.f3ae58f8.jpg";